<template>
  <div>
    <el-dialog
      title="填写退款信息"
      :visible.sync="dialogVisible"
      :show-close="false"
      :close-on-click-modal="false"
      :before-close="() => (_dialogVisible = false)"
      :modal-append-to-body="false"
      width="80%"
    >
      <el-form
        ref="listForm"
        :model="listParams"
        :rules="checkListParams"
        label-width="100px"
      >
        <el-row type="flex" class="row-bg" justify="space-between">
          <el-col>
            <el-form-item label="订单编号：" prop="orderId">
              <span>{{ orderItem.orderNo }}</span>
            </el-form-item></el-col
          >
          <el-col>
            <el-form-item
              label="原订单核销总金额:"
              label-width="250px"
              prop="orderId"
            >
              <span>{{ orderItem.amountTotal }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <el-table
            v-loading="goodLoading"
            :data="tableData"
            border
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection"> </el-table-column>
            <el-table-column align="center" label="商品" prop="productTitle">
              <template slot-scope="{ row }">
                <img
                  :src="row.productPicture"
                  style="width:100px;height:100px"
                  alt=""
                />
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="商品名称"
              prop="productTitle"
            />
            <el-table-column
              align="center"
              label="商品单价"
              prop="productPrice"
            />
            <el-table-column align="center" label="商品规格" prop="productSpec">
              <template slot-scope="{ row }">
                {{ row.productSpecWeight }}/{{ row.productSpec }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="商品数量"
              prop="productQuantity"
            />
            <el-table-column
              align="center"
              label="商品定金"
              prop="discountPrice"
            />
            <el-table-column
              align="center"
              label="核销金额"
              prop="tradeAmount"
            />
          </el-table>
        </el-form-item>
        <el-descriptions title="退款后订单合计">
          <el-descriptions-item label="商品数量 ">{{
            checkedList.length
          }}</el-descriptions-item>
          <el-descriptions-item label="商品定金">{{
            discountPrice
          }}</el-descriptions-item>
          <el-descriptions-item label="商品核销总金额">{{
            amountTotal
          }}</el-descriptions-item>
        </el-descriptions>
        <el-form-item label="退款原因：" prop="refundType">
          <el-select
            v-model="listParams.refundType"
            placeholder="请选择退款原因"
          >
            <el-option
              v-for="item in reasonList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="原因补充：" prop="reason">
          <el-input
            size="small"
            v-model.trim="listParams.reason"
            placeholder="请输入原因补充"
          />
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="_dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="onClickSubmit('listForm')"
          :disabled="submitLoading"
          :loading="submitLoading"
        >
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { refoundGoods, refound } from "../api";

const defaultParams = {
  orderId: "",
  refundType: "",
  reason: ""
};

export default {
  props: {
    dialogVisible: {
      type: Boolean,
      required: true,
      default: false
    },
    orderItem: {
      type: Object,
      default() {
        return {};
      }
    }
  },

  data() {
    return {
      submitLoading: false,
      listParams: Object.assign({}, defaultParams),
      checkListParams: {
        refundType: [
          { required: true, message: "请选择退款类型", trigger: "change" }
        ],
        refundAmount: [
          { required: true, message: "请输入退款金额", trigger: "blur" }
        ],
        reason: [{ required: true, message: "请输入原因补充", trigger: "blur" }]
      },
      reasonList: [
        { value: 10, label: "取消订单" },
        { value: 20, label: "退货部分退款" }
      ],
      goodLoading: false,
      checkedList: [],
      tableData: [],
      status: {
        1: "撤销",
        2: "正常",
        3: "部分退款"
      },
      amountTotal: 0,
      discountPrice: 0
    };
  },

  watch: {
    dialogVisible(value) {
      if (value) {
        if (this.orderItem.orderId) {
          this.listParams.orderId = this.orderItem.orderId;
          this.loadTable(this.orderItem.orderId);
        }
      }
    }
  },

  computed: {
    _dialogVisible: {
      get() {
        return this.dialogVisible;
      },
      set(val) {
        this.$emit("update:dialogVisible", val);
      }
    }
  },

  methods: {
    /**
     * 获取商品
     */
    loadTable(orderId) {
      this.goodLoading = true;
      refoundGoods(this, { orderId: orderId }).then(res => {
        this.tableData = res;
        this.goodLoading = false;
      });
    },
    /**
     * 选中商品
     */
    handleSelectionChange(val) {
      this.checkedList = val.map(item => {
        return item.tradeId;
      });
      this.discountPrice =
        val.reduce((pre, cur) => {
          return pre + cur.discountPrice * 100;
        }, 0) / 100;
      this.amountTotal =
        val.reduce((pre, cur) => {
          return pre + cur.tradeAmount * 100;
        }, 0) / 100;
    },
    /**
     * 点击提交
     */
    onClickSubmit(name) {
      this.$refs[name].validate(async valid => {
        if (valid) {
          const bodyParams = Object.assign(
            { tradeIds: this.checkedList },
            this.listParams
          );
          try {
            const response = await refound(this, bodyParams, "submitLoading");
            this.$message.success(response.info);
            this.$emit("success");
          } finally {
            this.handleReset();
          }
        }
      });
    },
    /**
     * 重置参数
     */
    handleReset() {
      this.listParams = Object.assign({}, defaultParams);
      this._dialogVisible = false;
    }
  }
};
</script>

<style lang="less" scoped></style>
